module.exports = __webpack_public_path__ + "static/media/vip_prepare.7bdb72a7.svg";